module.exports = __webpack_public_path__ + "img/suc.7b026528.gif";